export default __webpack_public_path__ + "static/media/email.66c06ace.svg";